<template>
  <div>
    <div id="footer">
      <div class="prefooter">
        <div class="row pt-3">
          <div class="col-sm-4 text-center pt-5">
            <img src="@/assets/home-page-images/footerLogo.png" alt />
          </div>
          <div class="col-sm-2">
            <!-- <ul>
              <li>{{ $t('FOOTER.HOME') }}</li>
              <li>{{ $t('FOOTER.ABOUT_US') }}</li>
              <li>{{ $t('FOOTER.FEATURED_PROJECTS') }}</li>
              <li>{{ $t('FOOTER.PARTNERSHIP_AVENUES') }}</li>
            </ul>-->
          </div>
          <div class="col-sm-2">
            <!-- <ul>
              <li>{{ $t('FOOTER.LNT_MARKETPLACE') }}</li>
              <li>{{ $t('FOOTER.PARTNER_WITH_US') }}</li>
              <li>{{ $t('FOOTER.TESTIMONIALS') }}</li>
            </ul>-->
          </div>
          <div class="col-sm-3">
            <ul>
              <li>
                <div class="row">
                  <div class="col-1">
                    <img src="@/assets/home-page-images/pin.svg" class="icon mr-3" alt />
                  </div>
                  <div class="col pl-3">
                    Mount Poonamallee Road, Manapakkam,
                    P.B.No.979, Chennai – 600 089.
                  </div>
                </div>
              </li>
              <!-- <li>
                <div class="row">
                  <div class="col-1">
                    <img src="@/assets/home-page-images/call-phone.svg" class="icon mr-3" alt />
                  </div>
                  <div class="col pl-3">
                    91-44-22526000, 22528000,
                    Fax:+91-44-2249 3317
                  </div>
                </div>
              </li>
              <li>
                <div class="row">
                  <div class="col-1">
                    <img src="@/assets/home-page-images/mail.svg" class="icon mr-3" alt />
                  </div>
                  <div class="col pl-3">Partnersupport@lntecc.com</div>
                </div>
              </li> -->
              <li>
                <div class="row">
                  <u
                    @click="goToGrievance()"
                    class="col pl-3"
                    style="
                   position: absolute;cursor:pointer;"
                  >International Grievance Registration Form</u>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div id="postFooter">
      <p>©{{getData()}} L&T Construction. All rights reserved</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "footerD",
  created() {},
  methods: {
    getData() {
      var d = new Date();
      var currentData = d.getFullYear();
      return currentData;
    },
    goToGrievance() {
      this.$router.push("/grievanceInternational");
    }
  }
};
</script>

<style scoped>
#footer {
  background-color: #222222;
  padding-top: 50px;
  padding-bottom: 45px;
}
#footer .prefooter {
  width: 95%;
  margin: 0 auto;
}
#footer img {
  width: 270px;
}
#footer ul {
  color: #fff;
  font-weight: normal;
  font-family: "Open Sans", sans-serif;
  font-size: 15px;
  letter-spacing: 1px;
  font-weight: 300;
  opacity: 0.8;
  list-style: none;
  padding: 0;
}
#footer ul li {
  margin: 10px auto;
  font-family: "Exo", sans-serif;
}
#footer ul .icon {
  width: 18px;
}
#postFooter {
  background-color: #0f0f0f;
  color: #ffffffdb;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
  letter-spacing: 1px;
}
#postFooter p {
  margin: 0;
}
</style>
